import { createApp, h } from '@vue/runtime-dom';
import App from './App.vue';
import router from './router/router';
import { ApolloClient, createHttpLink } from '@apollo/client/core';
import { setContext } from '@apollo/client/link/context';
import { createApolloProvider } from '@vue/apollo-option';
import { createCache } from './cache';
import digestString from './plugins/digestString';

window.__VUE_PROD_HYDRATION_MISMATCH_DETAILS__ = false

// 1. Setup Link with Dynamic Auth Header
const httpLink = createHttpLink({
  // This will now automatically pick the right URL based on your build mode
  uri: process.env.VUE_APP_GRAPHQL_URL,
});

const authLink = setContext((_, { headers }) => {
	// get the authentication token from local storage if it exists
	const token = localStorage.getItem('user-token') || sessionStorage.getItem('user-token');
	// return the headers to the context so httpLink can read them
	return {
		headers: {
			...headers,
			authorization: token ? token : "",
			'apollo-require-preflight': 'true'
		}
	}
});

// 2. Initialize the Client
const cache = createCache();
export const client = new ApolloClient({
	link: authLink.concat(httpLink),
	cache,
	connectToDevTools: true
});
export { cache };

// console.log ('test ' , window.__APOLLO_CLIENT__)

// 3. Initialize the Cache with Default Values
// ... existing code ...


const apolloProvider = createApolloProvider({
	defaultClient: client,
})

const app = createApp({
	render: () => h(App),
});

app.config.devtools = true; 
app.use(apolloProvider);
app.use(router);
app.use(digestString);
app.mount('#app');